/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { UICustomizationChallengeOptions } from './UICustomizationChallengeOptions';
import {
    UICustomizationChallengeOptionsFromJSON,
    UICustomizationChallengeOptionsFromJSONTyped,
    UICustomizationChallengeOptionsToJSON,
} from './UICustomizationChallengeOptions';

/**
 * 
 * @export
 * @interface UICustomizationChallenge
 */
export interface UICustomizationChallenge {
    /**
     * 
     * @type {string}
     * @memberof UICustomizationChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof UICustomizationChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof UICustomizationChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {UICustomizationChallengeOptions}
     * @memberof UICustomizationChallenge
     */
    options?: UICustomizationChallengeOptions;
}

/**
 * Check if a given object implements the UICustomizationChallenge interface.
 */
export function instanceOfUICustomizationChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function UICustomizationChallengeFromJSON(json: any): UICustomizationChallenge {
    return UICustomizationChallengeFromJSONTyped(json, false);
}

export function UICustomizationChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UICustomizationChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': !exists(json, 'options') ? undefined : UICustomizationChallengeOptionsFromJSON(json['options']),
    };
}

export function UICustomizationChallengeToJSON(value?: UICustomizationChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': UICustomizationChallengeOptionsToJSON(value.options),
    };
}

